"use client";

import { ttsLanguages, ttsAccents } from "@mw/shared/languagesAndAccents";
import dynamic from "next/dynamic";

import { Block } from "../Block";

function BlockLanguagesAccentsGlobeFallback() {
  return (
    <Block className='container' name='languages-accents-globe'>
      <div className='tw-min-h-[32rem] tw-w-full'>
        <ul className='tw-sr-only'>
          {ttsLanguages.map(lang => (
            <li key={lang.value}>{lang.label}</li>
          ))}
          {ttsAccents.map(accent => (
            <li key={accent.value}>{accent.label}</li>
          ))}
        </ul>
      </div>
    </Block>
  );
}

// 109 language/accent rows × DynamicFlag (Next/Image with srcset) × 2-3 copies
// (paginated list + modal) added ~50 KB of HTML the SEO crawl never benefits
// from beyond the language NAMES. Defer the interactive tree to client and
// keep just the names + minimal layout dimensions in initial HTML.
export const BlockLanguagesAccentsGlobeClient = dynamic(
  () => import("./BlockLanguagesAccentsGlobe").then(mod => mod.BlockLanguagesAccentsGlobe),
  { ssr: false, loading: () => <BlockLanguagesAccentsGlobeFallback /> },
);
